import React, { createContext, useContext, useState } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user,       setUser]       = useState(() => { try { return JSON.parse(localStorage.getItem('q_user')); } catch { return null; } });
  const [token,      setToken]      = useState(() => localStorage.getItem('q_token') || null);
  const [org,        setOrg]        = useState(() => { try { return JSON.parse(localStorage.getItem('q_org'));  } catch { return null; } });
  const [adminEmail, setAdminEmail] = useState(() => localStorage.getItem('q_admin_email') || 'admin@quoteology.com');

  const loginUser = (userData, tok, orgData = null, adminEmailVal = null) => {
    setUser(userData);
    setToken(tok);
    setOrg(orgData);
    setAdminEmail(adminEmailVal || 'admin@quoteology.com');
    localStorage.setItem('q_user',  JSON.stringify(userData));
    localStorage.setItem('q_token', tok);
    if (orgData)       localStorage.setItem('q_org',         JSON.stringify(orgData));
    else               localStorage.removeItem('q_org');
    if (adminEmailVal) localStorage.setItem('q_admin_email', adminEmailVal);
  };

  const logout = () => {
    setUser(null); setToken(null); setOrg(null);
    setAdminEmail('admin@quoteology.com');
    localStorage.removeItem('q_user');
    localStorage.removeItem('q_token');
    localStorage.removeItem('q_org');
    localStorage.removeItem('q_admin_email');
  };

  const isAdmin    = user?.role === 'admin';
  const plan       = org?.plan || null;   // 'essential' | 'standard' | 'enterprise' | null (internal admin)
  const hasFeature = (feature) => {
    if (!org) return true; // internal admin — unrestricted
    const limits = {
      essential:  { comparison: false, bulk_export: false },
      standard:   { comparison: true,  bulk_export: true  },
      enterprise: { comparison: true,  bulk_export: true  },
    };
    return limits[plan]?.[feature] ?? true;
  };

  return (
    <AuthContext.Provider value={{ user, token, org, adminEmail, loginUser, logout, isAdmin, plan, hasFeature }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);